import { apiGetFile, GetReportRequest } from 'api';

export const getOutstandingResponsesReportCsv = (request: GetReportRequest): Promise<Blob> =>
  apiGetFile('reports/outstandingresponses/csv', request);
